module.exports = __webpack_public_path__ + "img/FirstBg.516a3144.jpg";